import React from "react";
import { Modal } from "antd";
import { Close } from "@mui/icons-material";

const AiTargetLimitError = ({ preview, previewHandler }) => {
  return (
    <Modal
      className="ai-target-error-modal"
      open={preview}
      onCancel={previewHandler}
      width={600}
      footer={null}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Free Trial Limit Reached</h2>
      <p>
        You've reached the limit of your free trial for AI Target Generation. This feature
        allows you to create highly targeted and accurate results using our advanced AI
        models.
        <p>
          To continue enjoying uninterrupted access and unlock the full potential of AI
          Target Generation, please contact our team to discuss subscription options
          tailored to your needs.
        </p>
        <p>
          Our sales team will guide you through available plans, pricing, and benefits so
          you can choose the option that works best for you.
        </p>
      </p>
      <div className="action-box">
        <a
          href="mailto:internal@conceptor.ai"
          className="submit"
          style={{ padding: "0 25px" }}
          onClick={previewHandler}
        >
          Contact Sales
        </a>
      </div>
    </Modal>
  );
};

export default AiTargetLimitError;
